import React from 'react';
import PropTypes from 'prop-types';

export const StyledLink = ({ href, children }) => (
  <a
    href={href}
    style={{
      color: 'inherit',
      textDecoration: 'underline',
    }}
  >
    {children}
  </a>
);

StyledLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
